package org.hs_soft.runmynesto.domain.usecase.product.tab_selection

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.ProductSetsModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_selection.GetProductSetRepository

class GetProductSetUseCase(
    private val repository: GetProductSetRepository
) {
    suspend operator fun invoke(id: String): ProductSetsModel {
        return repository.getProductSet(id)
    }
}

